import { createContext } from 'react'

export const AiChatPanelContext = createContext<{
  openChat: () => void
  toggleChat: () => void
  open: boolean
} | null>(null)
